import { sections } from './service';
import { Effect } from 'umi';
import { Reducer } from '@@/plugin-dva/connect';

export interface ModularType {
  channelArray: [];
  value: string;
  loading: boolean;
  block_arr: [];
}

export interface ModelType {
  namespace: string;
  state: {
    channelArray: [];
    sections: [];
  };
  effects: {
    fetch: Effect;
    eliminate: Effect;
  };
  reducers: {
    save: Reducer;
    empty: Reducer;
  };
}

const Model: ModelType = {
  namespace: 'modular',

  state: {
    channelArray: [],
    sections: [],
  },

  effects: {
    *fetch({ payload, callback }, { call, put }) {
      const response = yield call(sections, payload);
      yield put({
        type: 'save',
        payload: {
          ...payload,
          ...response,
        },
      });
      if (callback) callback();
    },
    *eliminate({ payload, callback }, { call, put }) {
      yield put({
        type: 'empty',
      });
    },
  },
  reducers: {
    save(state, { payload }) {
      let section: any = {};
      if (payload.type === 'sections') {
        section = payload.data;
        section.show_head = 0;
      }
      const data =
        payload.type === 'sections' ? [section] : [...payload.data.sections];
      return {
        ...state,
        sections: data,
      };
    },
    empty(state, { payload }) {
      return {
        ...state,
        block_arr: [],
      };
    },
  },
};

export default Model;
